module.exports = __webpack_public_path__ + "img/plus-white2.69f06bbd.svg";